<template>
  <div>
    <p>L’atténuation de la chaleur ressentie dans les bâtiments ne dépend pas uniquement des améliorations à apporter sur les structures ou sur les équipements : nos comportements jouent un rôle essentiel dans la recherche du confort et doivent évoluer dans le bon sens.</p>
    <p>Par exemple, anticiper la fermeture des fenêtres et volets.</p>
  </div>
</template>